import React from "react";
import Icon from "../../../components/AppIcon";

const TransformationMetrics = ({ metrics }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
      {metrics?.map((metric, index) => (
        <div
          key={index}
          className="rounded-2xl p-6 flex flex-col items-center text-center gap-3 border-2 border-primary/20 bg-white shadow-sm"
        >
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name={metric?.icon} size={22} className="text-primary" />
          </div>
          <div className="text-3xl font-bold text-primary">{metric?.value}</div>
          <div className="text-sm font-bold text-gray-900">{metric?.label}</div>
          <p className="text-xs text-gray-600 leading-relaxed">{metric?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default TransformationMetrics;
